/**
 * PAGES where hide assistant (banner)
 */
const PAGES_TO_HIDE = [
    "simulatore-commerciale-1-minuto.html",
    "risultato-profilo-web.html",
    "dati-utente.html",
    "codice-otp.html",
];

const pagesIncludesUrl = (url = '') => {
    const founded = PAGES_TO_HIDE.find((itm) => {
        //return itm.indexOf(url) !== -1;
        return url.indexOf(itm) !== -1;
    });

    return founded ? true : false;
}

export const manageAssistant = (hide = true) => {
    /**
     * Example: 
     * pathname: "/simulatore/simulatore-commerciale.html"
     */
    const url = window.location.pathname;
    
    if(
        hide
        && pagesIncludesUrl(url)
    ) {
        /*
            window.hideAssistant = true;
        */
        //Changed on 25/01/23
        localStorage.setItem('hideAssistant', true);
        let ce = document.createEvent('CustomEvent');
        ce.initCustomEvent('compass-assistant-stop', false, false, {});
        window.dispatchEvent(ce);

    } else {
        /*
            window.hideAssistant = false;
        */
        //Changed on 25/01/23
        const hideAssistantLS = localStorage.getItem('hideAssistant');
        if(hideAssistantLS === 'true') {
            let ce = document.createEvent('CustomEvent');
            ce.initCustomEvent('compass-assistant-start', false, false, {});
            window.dispatchEvent(ce);

            localStorage.removeItem('hideAssistant');
        }
    }
}